import { IOrcamento } from "app/types/IOrcamento";

export function corrigirDatasOrcamento(orcamento: IOrcamento): IOrcamento {

    const dataPrecisaSerAjustada = (data:string) : boolean => data?.match?.(new RegExp(/\/Date\(\d+\)\//)) != null

    const ajustarData = (timestamp:number) : string => new Date(timestamp).toISOString().substring(0,10) + "T00:00:00"

    const extrairTimestamp = (data:string) : number => Number(data.match(new RegExp(/\d+/))[0])

    return {
        ...orcamento,
        DataPrevisaoEntrega: !dataPrecisaSerAjustada(orcamento.DataPrevisaoEntrega) ? orcamento.DataPrevisaoEntrega : ajustarData(extrairTimestamp(orcamento.DataPrevisaoEntrega)),
        DataMarcadaEntrega: !dataPrecisaSerAjustada(orcamento.DataMarcadaEntrega) ? orcamento.DataMarcadaEntrega : ajustarData(extrairTimestamp(orcamento.DataMarcadaEntrega)),
        DataValidade: !dataPrecisaSerAjustada(orcamento.DataValidade) ? orcamento.DataValidade : ajustarData(extrairTimestamp(orcamento.DataValidade))
    }
}
